import { EdgeType, NodeType } from "../models/common";

export const DEFAULT_NODE_PROPS = {
    position: { x: 0, y: 0 },
    type: NodeType.TopicPair,
};
export const DEFAULT_EDGE_PROPS = { type: EdgeType.Custom };
